/*
Copyright 2026 AB Civil Consulting

Notifies Element Desktop about call state changes for hold music functionality.
Sends postMessage to parent window with call join/leave and participant count events.
*/

const MESSAGE_TYPE = "element-call-state";

let isInCall = false;
let participantCount = 0;

function sendToParent(action: string, data: Record<string, unknown>): void {
    try {
        console.log("[CallStateNotifier] Sending to parent:", action, data);
        // Also log to prove postMessage is being called
        console.log("[CallStateNotifier] window.parent:", window.parent);
        console.log("[CallStateNotifier] window.parent === window:", window.parent === window);
        window.parent.postMessage({ type: MESSAGE_TYPE, action, data }, "*");
        console.log("[CallStateNotifier] postMessage sent successfully");
    } catch (e) {
        console.error("[CallStateNotifier] Failed to send:", e);
    }
}

export function notifyJoined(count: number): void {
    console.log("[CallStateNotifier] User joined call with", count, "participants");
    isInCall = true;
    participantCount = count;
    sendToParent("joined", { participantCount: count });
}

export function notifyLeft(): void {
    console.log("[CallStateNotifier] User left call");
    isInCall = false;
    participantCount = 0;
    sendToParent("left", {});
}

export function notifyParticipantCountChanged(count: number): void {
    if (count !== participantCount) {
        console.log("[CallStateNotifier] Participant count changed:", participantCount, "->", count);
        participantCount = count;
        if (isInCall) {
            sendToParent("participantCountChanged", { participantCount: count });
        }
    }
}

// Log on module load to prove it's being imported
console.log("[CallStateNotifier] ============================================");
console.log("[CallStateNotifier] Module loaded! This file is being executed.");
console.log("[CallStateNotifier] ============================================");

// Send a test message on load
setTimeout(() => {
    console.log("[CallStateNotifier] Sending test ping to parent...");
    sendToParent("ping", { timestamp: Date.now() });
}, 2000);
